var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarTrustpilotEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    className: "tp-star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    d: "m0,46.33l46.376,0l0,-46.33l-46.376,0l0,46.33z",
    fill: "#dcdce6",
    className: "tp-star__canvas"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#FFF",
    d: "m39.534,19.711l-26.304,19.09l3.838,-11.798l-10.047,-7.293l12.42,0l3.837,-11.798l3.837,11.798l12.419,0l0,0.001zm-16.255,11.8l7.183,-1.511l2.862,8.8l-10.045,-7.29l0,0.001z",
    className: "tp-star__shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarTrustpilotEmpty);
export default __webpack_public_path__ + "static/media/star_trustpilot_empty.808f6e3fffbe93ac0de86d68928c06c1.svg";
export { ForwardRef as ReactComponent };